<div class="information-popover-container">
    <div class="regle-row" *ngFor="let regle of regles">
        <lua-icone [iconName]="getIcon(regle.etat)" [color]="getColor(regle.etat)"></lua-icone>
        <p class="description" [ngClass]="{
            'etat-non-applicable': regle.etat === 2,
            'etat-erreur': regle.etat === 4
        }" >{{regle.description}}</p>
    </div>
	<div class="button-footer">
		<lua-bouton-texte libelle="Fermer" (click)="close()"></lua-bouton-texte>
	</div>
</div>